import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { ImportEquivalentsResultDialogComponent } from './import-equivalents-result-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class ImportEquivalentsResultGridLayoutService implements GridLayoutService<ImportEquivalentsResultDialogComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs() {
        return [{
            headerName: 'Entity',            
            field: 'entity',
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: {
                text: (params: any) => {
                  return (params.value != null && params.value.length > 0);
              }
            },
            maxWidth: 160,
            flex: 1            
        },
        {
            headerName: 'Error Condition',
            field: 'errorDesc',
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: {
                text: (params: any) => {
                  return (params.value != null && params.value.length > 0);
              }
            },
            maxWidth: 385,
            flex: 3      
        },{
            headerName: 'Line Number',            
            field: 'lineNumber',
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: {
                text: (params: any) => {
                  return (params.value != null && params.value.length > 0);
                }
            },
            maxWidth: 160,
            width: 160,
            flex: 1
        },];
    }
}
